WiseMetering.Views.IndicatorDetails = Backbone.Marionette.ItemView.extend({
    template: 'templates/indicators/details',

    modelEvents: {
        'change': 'render'
    },

    serializeData: function() {
        let json = this.model.toJSON();

        json.site = this.model.site();
        json.creator = this.model.get('creator_name');
        json.etl_name = this.model.etl()?.get('name');
        json.folders = this.model.folderNames(true);
        json.kind = this.model.kind().get('name');
        json.operation_name = this.model.operation_name(true);
        json.parent = this.model.parent();
        json.participations = this.model.participationsName(true);
        json.buckets = this.model.buckets().toJSON();
        json.raw_operation_name = this.model.raw_operation_name(true);
        json.timezone = this.model.timezone();
        json.updated_at = moment.unix(json.updated_at).format('YYYY/MM/DD HH:mm');
        json.updater = this.model.get('updater_name');

        return json;
    }
});
